import { makeStyles, tokens } from '@fluentui/react-components';

export const useInChatFeedbackSurveyStyles = makeStyles({
  surveyContent: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: tokens.spacingVerticalS,
  },
  header: {
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    marginTop: 0,
    marginBottom: 0,
  },
  sectionLabel: {
    fontWeight: tokens.fontWeightRegular,
    marginBottom: tokens.spacingVerticalXXS,
  },
  textarea: {
    width: '100%',
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-end',
    columnGap: tokens.spacingHorizontalS,
    marginTop: tokens.spacingVerticalXS,
  },
  submitButton: {
    alignSelf: 'flex-start',
  },
  thankYouContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'center',
  },
  thankYouCard: {
    width: '100%',
    backgroundColor: 'unset',
    boxShadow: 'unset !important',
    outline: 'unset',
    paddingLeft: '0',
  },
});
